export const route = {
  home: "/",
  login: "/",
  dashboard: "/dashboard",
  newOrder: "/new-order",
  newOrderList: "/new-order-list",
  openOrder: "/open-order",
  closedOrder: "/closed-order",
  orderDetails: "/order-details",

  newJobwork: "/new-jobwork/:typeId",
  newJobworkList: "/new-jobwork-list/:typeId",
  openJobwork: "/open-jobwork/:typeId",
  closedJobwork: "/closed-jobwork/:typeId",
  jobworkDetails: "/jobwork-details/:jobworkId/:typeId",

  newSample: "/new-sample",
  openSample: "/open-sample",
  closedSample: "/closed-sample",
  sampleDetails: "/sample-details",
};
